import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client/react';
import { client } from './lib/apollo';
import { ErrorBoundary } from './components/ui/ErrorBoundary';
import { Skeleton } from './components/ui/Skeleton';
import { CookieConsentProvider } from './context/CookieConsentContext';
import { CookieBanner } from './components/consent/CookieBanner';
import { CookiePreferences } from './components/consent/CookiePreferences';

const HomePage = lazy(() => import('./pages/HomePage').then(m => ({ default: m.HomePage })));
const ShopsPage = lazy(() => import('./pages/ShopsPage').then(m => ({ default: m.ShopsPage })));
const BarbershopPage = lazy(() => import('./pages/BarbershopPage').then(m => ({ default: m.BarbershopPage })));
const ManagePersonalInformationPage = lazy(() =>
  import('./pages/ManagePersonalInformationPage').then(m => ({ default: m.ManagePersonalInformationPage }))
);
const ManageBookingPage = lazy(() =>
  import('./pages/ManageBookingPage').then(m => ({ default: m.ManageBookingPage }))
);
const BarberProfilePage = lazy(() =>
  import('./pages/BarberProfilePage').then(m => ({ default: m.BarberProfilePage }))
);
const NotFoundPage = lazy(() => import('./pages/NotFoundPage').then(m => ({ default: m.NotFoundPage })));

function PageLoader() {
  return (
    <div className="min-h-screen bg-surface-800 flex items-center justify-center">
      <div className="space-y-4 w-full max-w-md px-4">
        <Skeleton className="h-8 w-48 mx-auto" />
        <Skeleton className="h-4 w-64 mx-auto" />
        <Skeleton className="h-40 w-full" />
      </div>
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <ApolloProvider client={client}>
        <CookieConsentProvider>
          <BrowserRouter>
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/shops" element={<ShopsPage />} />
                <Route path="/store/:barbershopId" element={<BarbershopPage />} />
                <Route path="/manage-personal-information" element={<ManagePersonalInformationPage />} />
                <Route path="/manage-booking" element={<ManageBookingPage />} />
                <Route path="/staff/:slug" element={<BarberProfilePage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Suspense>
            <CookieBanner />
            <CookiePreferences />
          </BrowserRouter>
        </CookieConsentProvider>
      </ApolloProvider>
    </ErrorBoundary>
  );
}
